(function(root, factory) {
  'use strict';
  var api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  if (root && root.document) api.boot(root);
})(typeof window !== 'undefined' ? window : null, function() {
  'use strict';

  var LINK = 'a[data-enigma-continue-shopping]';
  var POPUP = '.cart__popup_upsell';

  function localUrl(value, origin) {
    if (!value) return null;
    try {
      var url = new URL(value, origin);
      if (!/^https?:$/.test(url.protocol) || url.origin !== origin || url.username || url.password) return null;
      if (/%(?:2f|5c)/i.test(url.pathname)) return null;
      return url;
    } catch (error) {
      return null;
    }
  }

  function routeParts(url, origin, routeRoot) {
    var root = localUrl(routeRoot || '/', origin);
    if (!root) return null;
    var prefix = root.pathname.replace(/\/$/, '') + '/';
    if (url.pathname.indexOf(prefix) !== 0) return null;
    try {
      return url.pathname.slice(prefix.length).replace(/\/$/, '').split('/').map(decodeURIComponent);
    } catch (error) {
      return null;
    }
  }

  function validHandle(value) {
    return /^[a-z0-9][a-z0-9_-]*$/.test(value || '');
  }

  function parseCollectionUrl(value, origin, routeRoot) {
    var url = localUrl(value, origin);
    var parts = url && routeParts(url, origin, routeRoot);
    if (!parts || parts[0] !== 'collections' || !validHandle(parts[1]) || parts[1] === 'all') return null;
    var isProduct = parts.length === 4 && parts[2] === 'products' && validHandle(parts[3]);
    var isCollection = parts.length === 2 || parts.length === 3 && parts[2] !== 'products'
      && /^[a-z0-9][a-z0-9_+\-]*$/.test(parts[2]);
    if (!isProduct && !isCollection) return null;
    var root = localUrl(routeRoot || '/', origin).pathname.replace(/\/$/, '');
    return { url: url, collectionPath: root + '/collections/' + parts[1], isProduct: isProduct };
  }

  function relativeUrl(url) {
    return url.pathname + url.search + url.hash;
  }

  function collectionReturnUrl(context) {
    var url = new URL(context.url.href);
    // Keep storefront browsing state, not fragment-rendering or redirect parameters.
    Array.from(url.searchParams.keys()).forEach(function(name) {
      if (['q', 'view', 'page', 'sort_by', 'constraint', 'preview_theme_id', 'mtg_page_q', 'mtg_price_min', 'mtg_price_max'].indexOf(name) === -1
        && name.indexOf('filter.') !== 0) url.searchParams.delete(name);
    });
    return relativeUrl(url);
  }

  function resolveProductCategory(urls, origin, routeRoot) {
    var seen = Object.create(null);
    var best = null;
    var bestRank = 0;
    var ambiguous = false;
    (Array.isArray(urls) ? urls : []).forEach(function(value) {
      var category = parseCollectionUrl(value, origin, routeRoot);
      if (!category || category.isProduct || category.url.pathname.replace(/\/$/, '') !== category.collectionPath) return;
      var handle = category.collectionPath.split('/').pop();
      if (['all', 'frontpage', 'home', 'home-page', 'magic', 'yugioh', 'one_piece'].indexOf(handle) !== -1) return;
      if (seen[category.collectionPath]) return;
      seen[category.collectionPath] = true;
      // One Piece's general products category is subordinate to a specific one.
      var rank = handle === 'one-piece-products' ? 1 : 2;
      if (rank > bestRank) {
        best = category;
        bestRank = rank;
        ambiguous = false;
      } else if (rank === bestRank) {
        ambiguous = true;
      }
    });
    return best && !ambiguous ? collectionReturnUrl(best) : null;
  }

  function resolveTarget(options) {
    var current = localUrl(options.currentUrl, options.origin);
    if (!current) return { href: null, stayOnPage: false };
    var routeRoot = localUrl(options.routeRoot || '/', options.origin);
    // Direct Home purchases resume the current page, just like collection purchases.
    if (routeRoot && current.pathname.replace(/\/$/, '') === routeRoot.pathname.replace(/\/$/, '')) {
      return { href: relativeUrl(current), stayOnPage: true };
    }
    var context = parseCollectionUrl(current.href, options.origin, options.routeRoot);
    if (context && !context.isProduct) {
      return { href: relativeUrl(current), stayOnPage: true };
    }
    var parts = routeParts(current, options.origin, options.routeRoot);
    var isPdp = context && context.isProduct || parts && parts.length === 2 && parts[0] === 'products' && validHandle(parts[1]);
    if (!isPdp) return { href: null, stayOnPage: false };

    // Consume the already-resolved MTG back link; never reinterpret mtg_return/mtg_seq.
    var back = parseCollectionUrl(options.backUrl, options.origin, options.routeRoot);
    if (back && !back.isProduct) return { href: collectionReturnUrl(back), stayOnPage: false };
    var referrer = parseCollectionUrl(options.referrer, options.origin, options.routeRoot);
    if (referrer && !referrer.isProduct && (!context || referrer.collectionPath === context.collectionPath)) {
      return { href: collectionReturnUrl(referrer), stayOnPage: false };
    }
    return {
      href: context ? context.collectionPath : resolveProductCategory(options.productCategoryUrls, options.origin, options.routeRoot),
      stayOnPage: false
    };
  }

  function boot(windowObject) {
    if (!windowObject || !windowObject.document || windowObject.__enigmaContinueShoppingReady) return;
    windowObject.__enigmaContinueShoppingReady = true;
    var document = windowObject.document;
    var fallbacks = new WeakMap();

    function sync(link) {
      if (!link || !link.closest(POPUP)) return null;
      if (!fallbacks.has(link)) fallbacks.set(link, link.getAttribute('href'));
      var back = document.querySelector('[data-mtg-route-back]:not([hidden])');
      var result = resolveTarget({
        currentUrl: windowObject.location.href,
        origin: windowObject.location.origin,
        routeRoot: windowObject.Shopify && windowObject.Shopify.routes && windowObject.Shopify.routes.root || '/',
        referrer: document.referrer,
        backUrl: back && back.getAttribute('href'),
        productCategoryUrls: Array.prototype.map.call(document.querySelectorAll('[data-enigma-product-category-url]'), function(node) {
          return node.getAttribute('data-enigma-product-category-url');
        })
      });
      var href = result.href || fallbacks.get(link);
      if (href && link.getAttribute('href') !== href) link.setAttribute('href', href);
      return result;
    }

    function scan(scope) {
      if (!scope) return;
      if (scope.matches && scope.matches(LINK)) sync(scope);
      if (scope.querySelectorAll) Array.prototype.forEach.call(scope.querySelectorAll(LINK), sync);
    }

    document.addEventListener('click', function(event) {
      var link = event.target.closest && event.target.closest(LINK);
      var target = sync(link);
      if (!target || !target.stayOnPage || event.defaultPrevented || event.button !== 0
        || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey
        || link.hasAttribute('download') || link.target && link.target !== '_self') return;
      var popup = link.closest(POPUP);
      // Use the active cart popup's own close control and its existing cleanup callback.
      if (!popup.closest('.nov-wrap.nov-ready')) return;
      var close = popup.querySelector('button.nov-close');
      if (!close || close.disabled) return;
      event.preventDefault();
      close.click();
    });

    ['focusin', 'pointerover'].forEach(function(type) {
      document.addEventListener(type, function(event) {
        sync(event.target.closest && event.target.closest(LINK));
      });
    });
    windowObject.addEventListener('popstate', function() { scan(document); });
    if (typeof windowObject.MutationObserver === 'function' && document.documentElement) {
      new windowObject.MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          Array.prototype.forEach.call(mutation.addedNodes || [], function(node) {
            if (node.nodeType === 1) scan(node);
          });
        });
      }).observe(document.documentElement, { childList: true, subtree: true });
    }
    scan(document);
  }

  return { parseCollectionUrl: parseCollectionUrl, resolveProductCategory: resolveProductCategory, resolveTarget: resolveTarget, boot: boot };
});
